import { render, staticRenderFns } from "./StarRating.vue?vue&type=template&id=e4bd2cea&"
import script from "./StarRating.vue?vue&type=script&lang=js&"
export * from "./StarRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4bd2cea')) {
      api.createRecord('e4bd2cea', component.options)
    } else {
      api.reload('e4bd2cea', component.options)
    }
    module.hot.accept("./StarRating.vue?vue&type=template&id=e4bd2cea&", function () {
      api.rerender('e4bd2cea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-types/inputs/Rating/StarRating.vue"
export default component.exports